import * as fakeApp from "@/spa/fakeApp";
import {loadByOrder} from "@/spa/funcs.js";

export function isActive(location) {
	return location.hash.startsWith("#/crm/");
}

const files = [
	["/callcenter/scripts/vendor.js"] // we have the socket.io here
];

const spaconf = {
	name: "crm",
	async load() {
		return loadByOrder(files);
	},
	getAppConfig() {
		return fakeApp;
	}
};

export default spaconf;
